module.exports = __webpack_public_path__ + "img/logo-sportlerplus.be88381a.svg";